/* OFFLINE NATIVES v3 — Theme JS */
(function () {

  // ===== Topbar shrink on scroll =====
  var bar = document.getElementById('topbar');
  if (bar) {
    window.addEventListener('scroll', function () {
      bar.classList.toggle('scrolled', window.scrollY > 30);
    });
  }

  // ===== PDP variant picker =====
  function bindVariantPicker() {
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var form = document.getElementById('product-form');
    var variantsScript = section.querySelector('[data-product-variants]');
    if (!form || !variantsScript) return;

    var variants = [];
    try { variants = JSON.parse(variantsScript.textContent); }
    catch (e) { console.warn('Could not parse variants', e); return; }

    var sizeBtns = section.querySelectorAll('[data-size]');
    var colorBtns = section.querySelectorAll('[data-color]');
    var addBtn = section.querySelector('[data-add-btn]');
    var addBtnPrice = section.querySelector('[data-add-btn-price]');
    var mainPrice = section.querySelector('[data-main-price]');
    var sizeName = section.querySelector('[data-size-name]');
    var colorName = section.querySelector('[data-color-name]');
    var variantInput = section.querySelector('[data-variant-id]');
    var mobilePrice = document.getElementById('mobile-atc-price');

    var selected = { color: null, size: null };
    // Seed with initial selected values
    var activeColor = section.querySelector('[data-color].is-active');
    var activeSize = section.querySelector('[data-size].is-active');
    if (activeColor) selected.color = activeColor.dataset.color;
    if (activeSize) selected.size = activeSize.dataset.size;

    function formatPrice(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
    function findVariant() {
      return variants.filter(function (v) {
        var ok = true;
        if (selected.color) {
          var hasColor = (v.option1 === selected.color) || (v.option2 === selected.color) || (v.option3 === selected.color);
          if (!hasColor) ok = false;
        }
        if (selected.size) {
          var hasSize = (v.option1 === selected.size) || (v.option2 === selected.size) || (v.option3 === selected.size);
          if (!hasSize) ok = false;
        }
        return ok;
      })[0];
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      if (variantInput) variantInput.value = v.id;
      if (mainPrice) mainPrice.textContent = formatPrice(v.price);
      if (addBtnPrice) addBtnPrice.textContent = formatPrice(v.price);
      if (mobilePrice) mobilePrice.textContent = formatPrice(v.price);
      if (addBtn) {
        addBtn.disabled = !v.available;
        var label = addBtn.querySelector('span');
        if (label) label.textContent = v.available ? 'Add to Bag' : 'Sold Out';
      }
    }

    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.classList.contains('is-disabled')) return;
        sizeBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected.size = btn.dataset.size;
        if (sizeName) sizeName.textContent = selected.size;
        update();
      });
    });
    colorBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        colorBtns.forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        selected.color = btn.dataset.color;
        if (colorName) colorName.textContent = selected.color;
        update();
      });
    });

    var qtyVal = section.querySelector('[data-qty-val]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var qtyMinus = section.querySelector('[data-qty-minus]');
    var qtyPlus = section.querySelector('[data-qty-plus]');
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var v = parseInt(qtyVal.textContent);
      if (v > 1) { qtyVal.textContent = v - 1; if (qtyInput) qtyInput.value = v - 1; }
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      var v = parseInt(qtyVal.textContent);
      qtyVal.textContent = v + 1;
      if (qtyInput) qtyInput.value = v + 1;
    });

    update();
  }
  bindVariantPicker();

  // ===== Mobile sticky Add-to-Bag visibility =====
  (function () {
    var bar = document.getElementById('mobile-atc');
    var inlineBtn = document.querySelector('[data-add-btn]');
    if (!bar || !inlineBtn || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-mobile-atc');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '-100px 0px 0px 0px' });
    io.observe(inlineBtn);
  })();

  // ===== Cart sticky checkout visibility =====
  (function () {
    var bar = document.getElementById('mobile-checkout');
    var checkoutBtn = document.querySelector('.checkout-btn');
    if (!bar || !checkoutBtn || !('IntersectionObserver' in window)) return;
    document.body.classList.add('has-mobile-checkout');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        bar.classList.toggle('is-visible', !e.isIntersecting);
      });
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(checkoutBtn);
  })();

  // ===== Scroll-triggered reveals =====
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.style.opacity = 1;
          e.target.style.transform = 'translateY(0)';
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.08 });
    document.querySelectorAll('.card, .community .head, .community-cta, .newsletter, .shop-head, .cart-promo').forEach(function (el, i) {
      el.style.opacity = 0;
      el.style.transform = 'translateY(18px)';
      el.style.transition = 'opacity .7s ' + ((i % 8) * 50) + 'ms cubic-bezier(.2,.7,.2,1), transform .7s ' + ((i % 8) * 50) + 'ms cubic-bezier(.2,.7,.2,1)';
      io.observe(el);
    });
  }

  // ===== Mobile menu =====
  (function () {
    var burger = document.getElementById('mobBurger');
    var menu = document.getElementById('mobMenu');
    var closeBtn = document.getElementById('mobMenuClose');
    if (!menu) return;
    function openMenu() {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      if (burger) burger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('menu-open');
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      if (burger) burger.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }
    if (burger) burger.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', closeMenu); });
  })();

  // ===== Size Guide: open the first <details> when the anchor link is clicked =====
  function openSizeGuide() {
    var details = document.querySelector('#size-guide details');
    if (details) details.open = true;
  }
  document.querySelectorAll('a[href="#size-guide"]').forEach(function (link) {
    link.addEventListener('click', openSizeGuide);
  });
  if (window.location.hash === '#size-guide') openSizeGuide();
})();
